var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 318,
    height: 62.109,
    viewBox: "0 0 318 62.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228",
    transform: "translate(3206 -9044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M87.719,10.287V25.821A9.01,9.01,0,0,1,86.5,31.046a4.428,4.428,0,0,1-3.821,1.661,4.6,4.6,0,0,1-3.922-1.7,8.711,8.711,0,0,1-1.267-5.191V10.715H69.224V25.821a8.7,8.7,0,0,1-1.269,5.191,4.6,4.6,0,0,1-3.922,1.7,4.4,4.4,0,0,1-3.818-1.661C59.391,29.933,59,28.185,59,25.821V10.287H50.727V26.455q0,6.3,3.389,9.747t9.8,3.442a14.511,14.511,0,0,0,5.515-.942,9.043,9.043,0,0,0,3.924-3.083A9.116,9.116,0,0,0,77.306,38.7a14.433,14.433,0,0,0,5.429.942q6.371,0,9.814-3.442t3.444-9.747V10.287Z",
    transform: "translate(-3169.848 9051.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M109.326,27.313s.12-1.952.12-2.6a14.446,14.446,0,0,0-1.987-7.724A13.434,13.434,0,0,0,102.133,12a15.924,15.924,0,0,0-7.416-1.713,16.225,16.225,0,0,0-7.827,1.884,13.98,13.98,0,0,0-5.463,5.241,14.631,14.631,0,0,0-1.987,7.553,14.483,14.483,0,0,0,2.021,7.587,13.874,13.874,0,0,0,5.72,5.224,18.734,18.734,0,0,0,8.546,1.867q6.731,0,10.67-3.511l-2.672-2.672-.017-.017c-.188-.188-1.661-1.678-2.021-2.021a10.211,10.211,0,0,1-1.2.668c-.274.12-.5.223-.617.274a10.789,10.789,0,0,1-3.939.668,9.99,9.99,0,0,1-4.744-1.062c-1.045-.531-3.408-2.552-3.408-4.659Zm-21.546-5.1v-.017a7.089,7.089,0,0,1,1.473-3.2,2.936,2.936,0,0,1,.377-.428,6.734,6.734,0,0,1,5.087-2.021,7.239,7.239,0,0,1,4.35,1.319,5.9,5.9,0,0,1,2.5,4.35Z",
    transform: "translate(-3149.385 9051.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M127.187,4.093a5.433,5.433,0,0,0-3.717-1.267,5.3,5.3,0,0,0-3.717,1.319,4.356,4.356,0,0,0-1.422,3.29,4.3,4.3,0,0,0,1.422,3.288,5.809,5.809,0,0,0,7.433-.017,4.573,4.573,0,0,0,1.422-3.425,4.141,4.141,0,0,0-1.422-3.187m-7.844,40.455H127.6V16.031h-8.255Z",
    transform: "translate(-3121.667 9046.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M153.444,13.473a11.744,11.744,0,0,0-8.563-3.186,14.26,14.26,0,0,0-5.344.976,11.019,11.019,0,0,0-4.093,2.792l-7.9-3.34V39.233h8.272V25.119c0-2.535.617-4.453,1.85-5.737a6.529,6.529,0,0,1,4.984-1.935,5.464,5.464,0,0,1,4.3,1.661,7.437,7.437,0,0,1,1.49,5.07V39.233H156.7V22.909q0-6.268-3.254-9.437",
    transform: "translate(-3115.099 9051.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M156.638,4.093a5.433,5.433,0,0,0-3.717-1.267A5.3,5.3,0,0,0,149.2,4.145a4.356,4.356,0,0,0-1.422,3.29,4.3,4.3,0,0,0,1.422,3.288,5.809,5.809,0,0,0,7.433-.017,4.573,4.573,0,0,0,1.422-3.425,4.141,4.141,0,0,0-1.422-3.187m-7.844,40.455h8.272V16.031h-8.272Z",
    transform: "translate(-3100.678 9046.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M172.166,36.566a5.737,5.737,0,0,1-3.391,1.062,3.32,3.32,0,0,1-2.6-.993,3.945,3.945,0,0,1-.891-2.775V21.614h7.039V15.258h-7.039V3.91h-8.272V33.962q0,5.035,2.757,7.639t7.9,2.586a14.555,14.555,0,0,0,3.682-.445,8.329,8.329,0,0,0,3-1.353Z",
    transform: "translate(-3094.103 9046.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M189.532,10.537V22.885a8.219,8.219,0,0,1-1.8,5.755,6.228,6.228,0,0,1-4.778,1.937c-3.854,0-5.772-2.331-5.772-6.955V10.537h-8.272v14.3q0,6.425,3.288,9.627t8.906,3.2a12.645,12.645,0,0,0,4.658-.839,10.783,10.783,0,0,0,3.768-2.449v.959c0,2.62-.634,4.556-1.9,5.84-1.284,1.267-3.288,1.9-6.046,1.9a16.9,16.9,0,0,1-5.258-.856,13.455,13.455,0,0,1-4.4-2.329l-3.271,5.943a17.26,17.26,0,0,0,6.012,2.912,28.032,28.032,0,0,0,7.6,1.01q7.579,0,11.561-3.819c2.638-2.552,3.973-6.423,3.973-11.663V10.537Z",
    transform: "translate(-3085.804 9051.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M113.923,14.83a14.55,14.55,0,0,0-6.782,1.661V3.91h-7.9v25.6A14.678,14.678,0,1,0,113.923,14.83m0,22.232a7.223,7.223,0,0,1-6.782-5.1,7.81,7.81,0,0,1,0-4.9,7.218,7.218,0,0,1,6.782-5.121,7.376,7.376,0,0,1,7.176,7.57,7.371,7.371,0,0,1-7.176,7.553",
    transform: "translate(-3135.27 9046.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M32.792,53.494l-20.7-20.7,20.7-20.7Z",
    transform: "translate(-3197.386 9052.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M44.883,0V41.406h-.007l-20.7,20.7V20.7Z",
    transform: "translate(-3188.77 9044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M20.7,0V41.406L0,62.105V20.7Z",
    transform: "translate(-3206 9044)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.d85301ab21b5febf3d786040bb3ba7d3.svg";
export { ForwardRef as ReactComponent };